<!--
 * @Author: hongye
 * @Date: 2020-10-28 16:54:24
 * @LastEditTime: 2024-08-02 14:24:42
 * @Description: 
-->
<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
          class="main-r_top_nav active"
      >在线文档</span
      >
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom">
      <online-doc :onlineData="onlineData">
        <template #api_addr_info>
          <p class="api_addr_info">地址：使用接入方提供的URL</p>
          <p class="api_addr_info">请求方法：<span>POST</span></p>
          <p class="api_addr_info">数据类型：<span>X-WWW-FORM-URLENCODED </span></p>
          <p class="api_addr_info">响应类型：<span>JSON</span></p>
        </template>
      </online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
  import onlineDoc from "../components/onlineDoc";
  export default {
    name: "statusFeedback",

    components: {onlineDoc},
    data() {
      return {
        onlineData: {
          //接口描述
          apiDesc: "接入方在提供了快递轨迹推送相关信息并完成了下订单操作后，当订单相关的运单轨迹变化时，系统会根据接入方配置的推送账户主动推送物流信息。",

          //参数描述  START
          postDataList: [
            //   请求头参数
            {
              title: 'Headers',
              value: [
                {name: "apiAccount", type: "Number", require: "Y", normal: "", describe: "接入方在平台的api账户标识",},
                {name: "digest", type: "String", require: "Y", normal: "", describe: "签名字符串",},
                {name: "timestamp", type: "Number", require: "Y", normal: "", describe: "时间戳，毫秒",},
              ]
            },
             { 
                title:'请求参数', 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
                ]
            },
            {
              title: "业务参数",
              value: [
                {name: "billCode", type: "String(30)", require: "Y", normal: "", describe: "运单号"},
                {name: "txlogisticId", type: "String(60)", require: "N", normal: "", describe: "客户订单号"},
                {name: "details", type: "Array", require: "Y", normal: "", describe: "快递轨迹详情"}
              ]
            },
            {
              title:`details 参数说明`,
              value: [
                {name: "scanTime", type: "String", require: "Y", normal: "", describe: "扫描时间"},
                {name: "desc", type: "String", require: "Y", normal: "", describe: "轨迹描述"},
                {name: "scanType", type: "String", require: "Y", normal: "", describe: `扫描类型 <p>1、快件揽收</p> <p>2、入仓扫描（停用）</p> <p>3、发件扫描</p> <p>4、到件扫描</p> <p>5、出仓扫描</p> <p>6、入库扫描</p> <p>7、代理点收入扫描</p> <p>8、快件取出扫描</p> <p>9、出库扫描</p> <p>10、快件签收</p> <p>11、问题件扫描</p> <p>12、安检扫描</p> <p>13、其他扫描</p> <p>14、退件扫描</p>`},
                {name: "problemType",type: "String",require: "N",normal: "",describe: `<p>A1、客户取消寄件-网点</p> <p>A2、客户拒收</p> <p>A3、更改派送地址</p> <p>A4、退回件-网点</p><p>A7、异常件提醒</p> <p>A8、包裹异常-网点</p> <p>A9、收件人联系不上</p> <p>A10、收件人联系不上</p> <p>A11、多次派件失败</p> <p>A12、收件人信息错误</p> <p>A13、更改派送时间</p> <p>A14、客户拒收</p> <p>A15、收件地址不详</p> <p>A16、收件地址错误</p> <p>A17、包裹存放至网点</p> <p>A18、包裹存放至网点</p> <p>A19、收件地址禁止</p> <p>A20、包裹异常</p> <p>A21、包裹暂存网点</p> <p>A23、包裹延迟-节假日</p> <p>A24、包裹异常-中心</p> <p>A25、退回件-中心</p> <p>A26、客户取消寄件-中心</p><p>A27、异常天气</p><p>A28、自然灾害</p> <p>A29、代收/到付结算异议拒付</p> <p>A30、货未到齐</p> <p>A31、作废件</p> <p>A32、未录进仓编码</p> <p>A33、政府管制</p> <p>A34、乡镇件</p> <p>A35、发票问题客户拒收</p>`},
                {name: "scanNetworkName", type: "String", require: "Y", normal: "", describe: "扫描网点名称"},
                {name: "scanNetworkId", type: "String", require: "Y", normal: "", describe: "扫描网点ID"},
                {name: "staffName", type: "String", require: "Y", normal: "", describe: "业务员姓名"},
                {name: "staffContact", type: "String", require: "Y", normal: "", describe: "业务员联系方式"},
                {name: "scanNetworkContact", type: "String", require: "Y", normal: "", describe: "扫描网点联系方式"},
                {name: "scanNetworkProvince", type: "String", require: "Y", normal: "", describe: "扫描网点省份"},
                {name: "scanNetworkCity", type: "String", require: "Y", normal: "", describe: "扫描网点城市"},
                {name: "scanNetworkArea", type: "String", require: "Y", normal: "", describe: "扫描网点区/县"},
                {name: "nextStopName", type: "String", require: "Y", normal: "", describe: "上一站(到件)或下一站名称(发件)"},
                {name: "rebackStatus",type: "Number",require: "N",normal: "",describe: "退回件状态 0正常件 1退回件（10、快件签收时返回）"},
                {name: "networkType",type: "String",require: "Y",normal: "",describe: "网点类型  中心/网点/集散/其他"},
                {name: "signByOthersType",type: "String",require: "N",normal: "",describe: "代签收类型  驿站/快递柜 (6、入库扫描时返回)"},
                {name: "signByOthersName",type: "String",require: "N",normal: "",describe: "代收名称 (6、入库扫描时返回)"},
                {name: "signByOthersTel",type: "String",require: "N",normal: "",describe: "代收点电话 (6、入库扫描时返回)"},
                {name: "pickCode",type: "String",require: "N",normal: "",describe: "取件码 (6、入库扫描时返回)"}
              ]
            }
          ],
          //参数描述  END
          //报文描述 start
          responseDataList: [

            //   响应参数
            {
              title: '响应参数',
              value: [
                {name: "code", type: "String", require: "Y", normal: "", describe: "返回码，见附录"},
                {name: "msg", type: "String", require: "Y", normal: "", describe: "描述"},
                {name: "data", type: "String", require: "Y", normal: "", describe: "业务数据"},
              ]
            }
          ],
          //请求示例
          requestCode: `Header：
apiAccount=1362
digest=U40e5sumorgd3YgZzU61Mw==
timestamp=1565238848921



Body：
bizContent={
{
	"billCode": "1146708484138602002",
	"details": [{
            "billCode":"UT0000264445622",
            "desc":"【南京雨花台春江新城网点】您的极兔小哥 test1040 已取件。如需联系网点，请拨打 15850664590 特殊时期，您的牵挂，让极兔小哥为您速递！ᕱ ᕱ",
            "scanNetworkArea":"江宁区",
            "scanNetworkCity":"南京市",
            "scanNetworkContact":"15850664590",
            "scanNetworkId":1772,
            "scanNetworkName":"南京雨花台春江新城网点",
            "scanNetworkProvince":"江苏省",
            "scanNetworkTypeName":"南京雨花台春江新城网点",
            "scanTime":"2020-07-16 09:26:15",
            "scanType":"快件揽收"
        },
		{
            "billCode":"UT0000264445622",
            "desc":"亲，有您的快递！【南京玄武网点】的极兔小哥 test1042 (13123456789) 正带着包裹来见您，如需联系该网点，请拨打 17314954950 今天的极兔小哥，体温正常，口罩戴好，消毒到位，即将为您打call",
            "scanNetworkArea":"玄武区",
            "scanNetworkCity":"南京市",
            "scanNetworkContact":"17314954950",
            "scanNetworkId":33,
            "scanNetworkName":"南京玄武网点",
            "scanNetworkProvince":"江苏省",
            "scanNetworkTypeName":"南京玄武网点",
            "scanTime":"2020-07-16 09:26:31",
            "scanType":"出仓扫描"
        }	],
	"txlogisticId": "8792773877787"
}
}`,
          //返回示例
          responseCode: {
            'code': '1',
            'msg': 'success',
            'data':"SUCCESS"
        } ,
        errcodeJson: []
        }
      }
    },
    methods: {
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../css/apiTest.scss";
</style>
